<template>
  <div>
    <baseFrame
      :saveText="showSave" :submitText="showSubmit" clearText="" cancelText="" :isShowBtn="true"
      @save="submit(2)" @submit="submit(1)"
      :infosArr="infosArr"
      :subInfosArr="subInfosArr"
      :idText="idText"
      :id='code'
    >
      <div slot="content">
        <lk-card title="收款总计">
          <lk-form
            label-position='right'
            :labelWidth='120'>
            <lk-row>
              <lk-col span="8">
                <lk-form-item label='总销售收入:'>
                  <span>{{proceedsTotalInfo.amount}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="8">
                <lk-form-item label='总收款金额:'>
                  <div v-if="needChange">
                    <span>{{proceedsTotalInfo.proceedsAmount}}</span>
                    <span style="color: red">{{amountAdjust(proceedsTotalInfo.proceedsAmountAdjust)}}</span>
                  </div>
                  <div v-else>
                    <span>{{proceedsTotalInfo.proceedsAmount}}</span>
                  </div>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row>
              <div v-if="needChange">
                <lk-col span="8" v-for="(item, index) in proceedsTotalInfo.proceedsTypeList" :key="index">
                <lk-form-item :label='item.proceedsTypeName + ":"'>
                    <span>{{item.amount}}</span>
                    <span style="color: red">{{amountAdjust(item.amountAdjust)}}</span>
                </lk-form-item>
                </lk-col>
              </div>
              <div v-else>
                <lk-col span="8" v-for="(item, index) in proceedsTotalInfo.proceedsTypeList" :key="index">
                  <lk-form-item :label='item.proceedsTypeName + ":"'>
                    <span>{{item.amount}}</span>
                  </lk-form-item>
                </lk-col>
              </div>
            </lk-row>
            <lk-row>
              <lk-col span="8">
                <lk-form-item label='新增应收:'>
                  <span>{{proceedsTotalInfo.addReceivables}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="8">
                <lk-form-item label='应收核销:'>
                  <span>{{proceedsTotalInfo.receivablesVerification}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row>
              <lk-col span="8">
                <lk-form-item label='新增预收:'>
                  <span>{{proceedsTotalInfo.addDeposit}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="8">
                <lk-form-item label='预收核销:'>
                  <div v-if="needChange">
                    <span>{{proceedsTotalInfo.depositVerification}}</span>
                    <span style="color: red">{{amountAdjust(proceedsTotalInfo.depositVerificationAdjust)}}</span>
                  </div>
                  <div v-else>
                    <span>{{proceedsTotalInfo.depositVerification}}</span>
                  </div>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row>
              <lk-col span="8">
                <lk-form-item label='预收退款:'>
                  <span>{{proceedsTotalInfo.depositRefund}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="8">
                <lk-form-item label='预收核销退回:'>
                  <span>{{proceedsTotalInfo.depositVerificationRefund}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
        <lk-card class="card-space" title="销售订单">
          <span slot="extra" style="margin: 10px">{{salesExtra}}</span>
          <a slot="extra" @click.prevent="confirmation(0)" v-if="this.retailDailyRevision">
          <lk-icon type="ios-loop-strong"></lk-icon>
            批量确认无误
          </a>
          <lk-table
            :data='saleOrderListData'
            :columns='saleOrderList'
            border
          >
          </lk-table>
        </lk-card>
        <lk-card class="card-space" title="销售退货单">
          <span slot="extra" style="margin: 10px">{{returnListExtra}}</span>
          <a slot="extra" @click.prevent="confirmation(1)" v-if="this.retailDailyRevision">
          <lk-icon type="ios-loop-strong"></lk-icon>
            批量确认无误
          </a>
          <lk-table
            :data='saleRefundListData'
            :columns='saleRefundList'
            border
          >
          </lk-table>
        </lk-card>
        <lk-card class="card-space" title="收款单">
          <span slot="extra" style="margin: 10px">{{proceedsListExtra}}</span>
          <a slot="extra" @click.prevent="confirmation(2)" v-if="this.retailDailyRevision">
          <lk-icon type="ios-loop-strong"></lk-icon>
            批量确认无误
          </a>
          <lk-table
            :data='financeDepositListData'
            :columns='financeDepositList'
            border
          >
          </lk-table>
        </lk-card>
        <lk-card class="card-space" title="订正记录" v-if="verifyListData.length">
          <lk-table
            :data='verifyListData'
            :columns="this.retailDailyVerify ? verifyList : verifyListCheck"
            border
          >
          </lk-table>
        </lk-card>
      </div>
    </baseFrame>
    <RevisionModal
      v-model="showRevisionModal"
      :formConfig.sync="formConfig"
      :deposits="depositList"
      :formInfo="formInfo"
      @revisionSave="revisionSave"
    ></RevisionModal>
    <lk-modal
      v-model="revisionSelectModal"
      title="单据订正"
      width='450'
      :mask-closable="false"
      :closable="false"
    >
      <lk-form
        :model="formInfo"
        :label-width="100"
      >
        <lk-form-item label="订单类型:" >
          <span>{{formInfo.orderTypeName}}</span>
        </lk-form-item>
        <lk-form-item label="订正订单:" >
          <span>{{formInfo.bizCode}}</span>
        </lk-form-item>
        <lk-form-item label="订正类型:" >
          <lk-select
            class="depositItem"
            style="width: 200px"
            v-model="formInfo.type"
          >
            <lk-option v-for="(item,i) in tempRevisionList" :value='item.id' :key="i">
              {{item.name}}
            </lk-option>
          </lk-select>
        </lk-form-item>
      </lk-form>
      <div slot="footer">
        <lk-button @click="cancel">取消</lk-button>
        <lk-button type="primary" @click="handlerNext">下一步</lk-button>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import utils from '../../libs/utils';
import baseFrame from '../../components/frame/BaseFrame.vue';
import finance from '../../services/finance';
import system from '../../services/system';
import sale from '../../services/sale';
import RevisionModal from '../../components/finance/RevisionModal.vue';

export default {
  name: 'PorceedInfoInfo',
  components: {
    baseFrame,
    RevisionModal,
  },
  data() {
    return {
      showRevisionModal: false,
      revisionSelectModal: false,
      formInfo: {
        orderTypeName: '销售订单',
        type: 1, // 订正类型
        proceedsId: '', // 零售日报id
        bizCode: '', // 关联单号
        bizType: '', // 单据类型，1销售订单、2销售退货单、3预收单、4收款单退款
        revisionType: '', // 订正类型：1.销售订单-收款方式、2.销售订单-销项税率、3.退货单-收款方式、4.收款单-收款方式、5.收款单-退款方式
        newValueList: [], // 修改后的内容
        reason: '', // 订正原因
      },
      orderTypeList: {
        1: '销售订单',
        2: '销售退货单',
        3: '收款单',
        4: '收款单',
      },
      paymentListCopyed: [],
      paymentList: [], // 收款方式
      depositList: [], // 预收单
      tempDepositList: [], // 处理bug，暂存列表
      tableColumns: [
        {
          title: '商品编码',
          key: 'drugSerialCode',
          minWidth: 100,
        },
        {
          title: '通用名',
          key: 'approvedDrugNames',
          minWidth: 100,
        },
        {
          title: '商品名',
          key: 'goodsName',
          minWidth: 100,
        },
        {
          title: '规格',
          key: 'specifications',
          minWidth: 70,
        },
        {
          title: '生产企业',
          key: 'manufacturer',
          minWidth: 90,
        },
        {
          title: '单位',
          key: 'drugMiniPackageUnit',
          minWidth: 60,
        },
        {
          title: '原销项税率',
          key: 'outputTaxRate',
          minWidth: 94,
        },
        {
          title: '新销项税率',
          key: 'outputTaxRateNew',
          minWidth: 94,
        },
      ],
      formConfig: { // 订正配置
      },
      revisionList: [
        {
          id: 1,
          name: '修改收款方式',
        },
        {
          id: 2,
          name: '更新销项税率',
        },
      ],
      tempRevisionList: [],
      tempSaleOrderDetailList: [], // 暂存saleOrderDetailList
      infosArr: [], // 零售日报详情头部信息
      subInfosArr: [],
      code: '',
      idText: '日报编号',
      verifyStatus: ['待核验', '已核验', '待订正', '已过期'],
      verifyStatusPage: '', // 当前页面状态
      pushStatus: ['已推送', '未推送'],
      bizType: ['销售订单', '销售退货单', '收款单', '收款单(退款)'],
      revisionType: ['收款方式', '销项税率', '收款方式', '收款方式', '收款方式'],
      verifyResult: ['确认无误', '需修改'],
      returnStatus: ['草稿', '审批中', '审批通过', '审批未通过', '已删除'],
      ruleValidate: {},
      saleOrderListData: [], // 销售订单数据
      saleRefundListData: [], // 销售退货单数据
      financeDepositListData: [], // 收款单数据
      verifyListData: [], // 订正记录数据
      proceedsTotalInfo: { // 收款总计
        amount: '',
        proceedsAmount: '',
        addReceivables: '',
        receivablesVerification: '',
        addDeposit: '',
        depositVerification: '',
        proceedsTypeList: [
          {
            proceedsTypeName: '',
            amount: '',
          },
        ],
      },
      saleOrderDetailList: [ // 销售订单子表格
        { title: '商品编码', key: 'drugSerialCode', minWidth: 116 },
        { title: '通用名', key: 'approvedDrugNames', minWidth: 116 },
        { title: '商品名', key: 'goodsName', minWidth: 116 },
        { title: '规格', key: 'specifications', minWidth: 116 },
        { title: '生产企业', key: 'manufacturer', minWidth: 116 },
        { title: '单位', key: 'goodsUnit', minWidth: 116 },
        {
          title: '销项税率',
          key: 'outputTaxRate',
          minWidth: 116,
          render: (h, params) => h('span', {
            style: {
              color: params.row.taxRates && params.row.taxRates.tax === 1 && this.needChange ? 'red' : '',
            },
          }, params.row.outputTaxRate),
        },
        { title: '销售数量', key: 'goodsCount', minWidth: 116 },
        { title: '含税单价', key: 'realPrice', minWidth: 116 },
        { title: '含税金额', key: 'amount', minWidth: 116 },
        { title: '批号', key: 'goodsLot', minWidth: 116 },
        { title: '批次', key: 'goodsBatch', minWidth: 116 },
        { title: '供应商', key: 'supplierName', minWidth: 116 },
      ],
      saleRefundDetailList: [ // 退货单明细
        { title: '商品编码', key: 'drugSerialCode', minWidth: 116 },
        { title: '通用名', key: 'approvedDrugNames', minWidth: 116 },
        { title: '商品名', key: 'goodsName', minWidth: 116 },
        { title: '规格', key: 'specifications', minWidth: 116 },
        { title: '生产企业', key: 'manufacturer', minWidth: 116 },
        { title: '单位', key: 'drugMiniPackageUnit', minWidth: 116 },
        { title: '销项税率', key: 'outputTaxRate', minWidth: 116 },
        { title: '退货数量', key: 'refundNum', minWidth: 116 },
        { title: '含税单价', key: 'refundPrice', minWidth: 116 },
        { title: '含税金额', key: 'refundAmount', minWidth: 116 },
        { title: '退货原因', key: 'refundReason', minWidth: 116 },
        { title: '批号', key: 'batchCode', minWidth: 116 },
        { title: '批次', key: 'batchSeq', minWidth: 116 },
        { title: '供应商', key: 'supplierName', minWidth: 116 },
      ],
      saleOrderList: [ // 销售订单表格
        {
          type: 'expand',
          width: 50,
          render: (h, params) => h('lk-table', {
            props: {
              columns: this.saleOrderDetailList,
              data: params.row.saleOrderDetailList,
            },
          }),
        },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        { title: '销售订单号', key: 'orderNo', minWidth: 116 },
        { title: '订单类型', key: 'type', minWidth: 116 },
        { title: '订单状态', key: 'statusName', minWidth: 116 },
        { title: '收款状态', key: 'proceedsStatus', minWidth: 116 },
        { title: '签收状态', key: 'signStatus', minWidth: 116 },
        { title: '订单金额', key: 'totalAmount', minWidth: 116 },
        { title: '折扣金额', key: 'discount', minWidth: 116 },
        { title: '应收总额', key: 'receivablesTotal', minWidth: 116 },
        {
          title: '收款金额',
          key: 'proceedsAmountString',
          minWidth: 130,
          render: (h, params) => h('span', {
            style: {
              color: params.row.flag === 1 && params.row.proceedsAmountString && this.needChange ? 'red' : '',
            },
          }, params.row.proceedsAmountString ? params.row.proceedsAmountString : '-'),
        },
        {
          title: '核销关系',
          key: 'depositStringAll',
          minWidth: 130,
          render: (h, params) => h('span', {
            style: {
              color: params.row.flag === 1 && params.row.depositStringAll && this.needChange ? 'red' : '',
            },
          }, params.row.depositStringAll ? params.row.depositStringAll : '-'),
        },
        { title: '剩余应收', key: 'receivables', minWidth: 116 },
        {
          title: '购药人',
          key: 'contact',
          minWidth: 116,
          render: (h, params) => h('span', params.row.contact ? params.row.contact : '-'),
        },
        {
          title: '核对结果',
          minWidth: 120,
          fixed: 'right',
          render: (h, params) => h('div', [
            this.retailDailyRevision ? h('lk-radio-group', {
              props: {
                value: params.row.verifyStatus,
              },
              on: {
                'on-change': (status) => {
                  this.$set(this.saleOrderListData[params.index], 'verifyStatus', status);
                },
              },
            }, [
              h('lk-radio', {
                props: {
                  label: 1,
                },
              }, '确认无误'),
              h('lk-radio', {
                props: {
                  label: 2,
                },
              }, '需修改'),
            ]) : h('span', {
              style: {
                color: params.row.verifyStatus === 2 ? 'red' : 'black',
              },
            }, this.verifyResult[params.row.verifyStatus - 1] ? this.verifyResult[params.row.verifyStatus - 1] : '-'),
          ]),
        },
        {
          title: '备注',
          key: 'remarks',
          fixed: 'right',
          minWidth: 116,
          render: (h, params) => h('div', [
            this.retailDailyRevision ? h('lk-input', {
              on: {
                'on-blur': (e) => {
                  if (e.target.value) {
                    this.$set(this.saleOrderListData[params.index], 'remarks', e.target.value);
                  }
                },
              },
              props: {
                value: params.row.remarks,
                placeholder: '请输入',
              },
            }) : h('span', params.row.remarks ? params.row.remarks : '-'),
          ]),
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 116,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  const routeData = this.$router.resolve({ name: 'salesOrderCheck', params: { id: params.row.referId } });
                  window.open(routeData.href, '_blank');
                },
              },
            }, '详情'),
            this.retailDailyVerify && params.row.verifyStatus === 2 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.handlerRevision(params.row);
                  const saleOrderDetailList = params.row.saleOrderDetailList;
                  if (saleOrderDetailList && saleOrderDetailList.length) {
                    const goodsBaseIdList = saleOrderDetailList.map(item => item.goodsBaseId);
                    this.getPaymentList(goodsBaseIdList);
                  }
                },
              },
            }, '订正') : null,
          ]),
        },
      ],
      saleRefundList: [// 销售退货单表格
        {
          type: 'expand',
          width: 50,
          render: (h, params) => h('lk-table', {
            props: {
              columns: this.saleRefundDetailList,
              data: params.row.saleRefundDetailList,
            },
          }),
        },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        { title: '审核通过时间', key: 'modifiedTime', minWidth: 116 },
        { title: '退货单号', key: 'code', minWidth: 116 },
        { title: '状态', key: 'status', minWidth: 116 },
        { title: '退货总金额', key: 'amount', minWidth: 116 },
        {
          title: '退款金额',
          key: 'proceedsAmountString',
          minWidth: 130,
          render: (h, params) => h('span', {
            style: {
              color: params.row.showNewValue && this.needChange ? 'red' : '',
            },
          }, params.row.showNewValue ? params.row.newValue : params.row.proceedsAmountString),
        },
        {
          title: '预收核销退回',
          key: 'depositAmountString',
          minWidth: 130,
          render: (h, params) => h('span', {
            style: {
              color: params.row.showNewDepositAmountString ? 'red' : '',
            },
          }, params.row.showNewDepositAmountString ? params.row.newDepositAmountString : params.row.depositAmountString),
        },
        { title: '关联销售订单', key: 'orderCode', minWidth: 116 },
        {
          title: '核对结果',
          minWidth: 120,
          fixed: 'right',
          render: (h, params) => h('div', [
            this.retailDailyRevision ? h('lk-radio-group', {
              props: {
                value: params.row.verifyStatus,
              },
              on: {
                'on-change': (status) => {
                  this.$set(this.saleRefundListData[params.index], 'verifyStatus', status);
                },
              },
            }, [
              h('lk-radio', {
                props: {
                  label: 1,
                },
              }, '确认无误'),
              h('lk-radio', {
                props: {
                  label: 2,
                },
              }, '需修改'),
            ]) : h('span', {
              style: {
                color: params.row.verifyStatus === 2 ? 'red' : 'black',
              },
            }, this.verifyResult[params.row.verifyStatus - 1] ? this.verifyResult[params.row.verifyStatus - 1] : '-'),
          ]),
        },
        {
          title: '备注',
          key: 'remarks',
          fixed: 'right',
          minWidth: 116,
          render: (h, params) => h('div', [
            this.retailDailyRevision ? h('lk-input', {
              on: {
                'on-blur': (e) => {
                  if (e.target.value) {
                    this.$set(this.saleRefundListData[params.index], 'remarks', e.target.value);
                  }
                },
              },
              props: {
                value: params.row.remarks,
                placeholder: '请输入',
              },
            }) : h('span', params.row.remarks ? params.row.remarks : '-'),
          ]),
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 116,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  const routeData = this.$router.resolve({ name: 'saleRefundList' });
                  window.open(routeData.href, '_blank');
                },
              },
            }, '详情'),
            this.retailDailyVerify && params.row.verifyStatus === 2 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.handlerRevision(params.row);
                },
              },
            }, '订正') : null,
          ]),
        },
      ],
      financeDepositList: [// 收款单表格
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        { title: '类型', key: 'depositType', minWidth: 116 },
        { title: '收款单号', key: 'depositCode', minWidth: 116 },
        {
          title: '收款方式',
          key: 'proceedsTypeName',
          minWidth: 116,
          render: (h, params) => h('span', {
            style: {
              color: params.row.newValue && this.needChange ? 'red' : '',
            },
          }, params.row.newValue ? params.row.newValue : params.row.proceedsTypeName),
        },
        {
          title: '收款金额',
          key: 'proceedsAmount',
          minWidth: 130,
          render: (h, params) => h('span', params.row.proceedsAmount ? params.row.proceedsAmount : '-'),
        },
        {
          title: '付款人',
          key: 'paymentUserName',
          minWidth: 116,
          render: (h, params) => h('span', params.row.paymentUserName ? params.row.paymentUserName : '-'),
        },
        { title: '核销关系', key: 'saleOrderListString', minWidth: 130 },
        {
          title: '核销总金额',
          key: 'receivables',
          minWidth: 116,
          render: (h, params) => h('span', params.row.receivables ? params.row.receivables : '-'),
        },
        {
          title: '剩余金额',
          key: 'deposit',
          minWidth: 116,
          render: (h, params) => h('span', params.row.deposit ? params.row.deposit : '-'),
        },
        {
          title: '核对结果',
          minWidth: 120,
          fixed: 'right',
          render: (h, params) => h('div', [
            this.retailDailyRevision ? h('lk-radio-group', {
              props: {
                value: params.row.verifyStatus,
              },
              on: {
                'on-change': (status) => {
                  this.$set(this.financeDepositListData[params.index], 'verifyStatus', status);
                },
              },
            }, [
              h('lk-radio', {
                props: {
                  label: 1,
                },
              }, '确认无误'),
              h('lk-radio', {
                props: {
                  label: 2,
                },
              }, '需修改'),
            ]) : h('span', {
              style: {
                color: params.row.verifyStatus === 2 ? 'red' : 'black',
              },
            }, this.verifyResult[params.row.verifyStatus - 1] ? this.verifyResult[params.row.verifyStatus - 1] : '-'),
          ]),
        },
        {
          title: '备注',
          key: 'remarks',
          fixed: 'right',
          minWidth: 116,
          render: (h, params) => h('div', [
            this.retailDailyRevision ? h('lk-input', {
              on: {
                'on-blur': (e) => {
                  if (e.target.value) {
                    this.$set(this.financeDepositListData[params.index], 'remarks', e.target.value);
                  }
                },
              },
              props: {
                value: params.row.remarks,
                placeholder: '请输入',
              },
            }) : h('span', params.row.remarks ? params.row.remarks : '-'),
          ]),
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 116,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  const referId = params.row.bizType == 4 ? params.row.referDepositId : params.row.referId;
                  const routeData = this.$router.resolve({ name: 'proceedCheck', params: { id: referId } });
                  window.open(routeData.href, '_blank');
                },
              },
            }, '详情'),
            this.retailDailyVerify && params.row.verifyStatus === 2 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.handlerRevision(params.row);
                },
              },
            }, '订正') : null,
          ]),
        },
      ],
      verifyList: [// 订正记录表格查看\核验
        { title: '单据号', key: 'bizCode', minWidth: 116 },
        {
          title: '单据类型',
          key: 'bizType',
          minWidth: 116,
          render: (h, params) => h('span', this.bizType[params.row.bizType - 1]),
        },
        {
          title: '订正时间',
          key: 'createTime',
          minWidth: 120,
          render: (h, params) => h('span', utils.exchangeTimeToSecond(params.row.createTime)),
        },
        {
          title: '订正类型',
          key: 'revisionType',
          minWidth: 116,
          render: (h, params) => h('span', this.revisionType[params.row.revisionType - 1]),
        },
        {
          title: '订正前', key: 'oldValue', minWidth: 130, tooltip: true,
        },
        {
          title: '订正后', key: 'newValueDescription', minWidth: 116, tooltip: true,
        },
        { title: '订正原因', key: 'reason', minWidth: 116 },
        { title: '订正人', key: 'createUserName', minWidth: 116 },
        {
          title: '操作',
          key: 'action',
          minWidth: 90,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          },
          [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.cancelRevision(params.row.id);
                },
              },
            }, '取消订正'),
          ]),
        },
      ],
      verifyListCheck: [
        { title: '单据号', key: 'bizCode', minWidth: 116 },
        {
          title: '单据类型',
          key: 'bizType',
          minWidth: 116,
          render: (h, params) => h('span', this.bizType[params.row.bizType - 1]),
        },
        {
          title: '订正时间',
          key: 'createTime',
          minWidth: 120,
          render: (h, params) => h('span', utils.exchangeTimeToSecond(params.row.createTime)),
        },
        {
          title: '订正类型',
          key: 'revisionType',
          minWidth: 116,
          render: (h, params) => h('span', this.revisionType[params.row.revisionType - 1]),
        },
        { title: '订正前', key: 'oldValue', minWidth: 130, tooltip: true, },
        { title: '订正后', key: 'newValueDescription', minWidth: 116, tooltip: true, },
        { title: '订正原因', key: 'reason', minWidth: 116 },
        { title: '订正人', key: 'createUserName', minWidth: 116 },
      ],
      orderNumber: [], // 订单数量 0：销售订单； 1：销售退货单； 2：收款单
      orderVerificationNum: [], // 订单核验数量 0：销售订单； 1：销售退货单； 2：收款单
      type: ['店销', '配送'],
      status: ['待完成', '已完成', '取消中', '已取消', '已完成'],
      signStatus: ['已发货', '已收货', '待发货', '待确认发货'],
      proceedsStatus: ['已收款', '部分收款', '未收款'],
    };
  },
  computed: {
    salesExtra() {
      let num1 = 0;
      let num2 = 0;
      this.saleOrderListData.forEach((item) => {
        if (item.verifyStatus === 1) {
          num1++;
        } else if (item.verifyStatus === 2) {
          num2++;
        }
      });
      return `共计${this.saleOrderListData.length}单，已核对${num1}单，需订正${num2}单`;
    },
    returnListExtra() { // 退货单右上角
      let num1 = 0;
      let num2 = 0;
      this.saleRefundListData.forEach((item) => {
        if (item.verifyStatus === 1) {
          num1++;
        } else if (item.verifyStatus === 2) {
          num2++;
        }
      });
      return `共计${this.saleRefundListData.length}单，已核对${num1}单，需订正${num2}单`;
    },
    proceedsListExtra() { // 退货单右上角
      let num1 = 0;
      let num2 = 0;
      this.financeDepositListData.forEach((item) => {
        if (item.verifyStatus === 1) {
          num1++;
        } else if (item.verifyStatus === 2) {
          num2++;
        }
      });
      return `共计${this.financeDepositListData.length}单，已核对${num1}单，需订正${num2}单`;
    },
    showSave() {
      return this.retailDailyRevision ? '保存' : '';
    },
    showSubmit() {
      return this.$route.name !== 'retailDailyCheck' ? '提交' : '';
    },
    retailDailyRevision() { // 是否是核验（路径名称错误正确应该是verify）
      return this.$route.name === 'retailDailyRevision';
    },
    retailDailyVerify() { // 是否是订正（路径名称错误正确应该是revision）
      return this.$route.name === 'retailDailyVerify';
    },
    retailDailyCheck() { // 是否是查看页
      return this.$route.name === 'retailDailyCheck';
    },
    needChange() { // 需要展示修改内容
      return this.verifyStatusPage === '待核验' || this.verifyStatusPage === '待订正';
    },
  },
  watch: {
    paymentList: {
      handler() {
        this.formConfig.subParams.paymentList = this.paymentList.filter(item => !([6].includes(item.proceedsTypeId)));
      },
      deep: true,
    },
  },
  methods: {
    // 取消订正
    cancelRevision(id) {
      const params = {
        id,
      };
      finance.revisionDel(params).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('取消成功');
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // 订正保存
    revisionSave() {
      // this.formInfo.type = 1; // 重置选项/
      const {
        proceedsId,
        bizCode,
        bizType,
        bizId,
        revisionType,
      } = this.formInfo;
      const {
        advanceAmountList,
        paymentList,
        reason,
        selectPayment,
        saleOrderDetailList,
        refundList,
        refundData,
      } = this.formConfig.subParams;
      const params = {
        proceedsId,
        bizCode,
        bizType,
        bizId,
        revisionType,
        newValueList: [],
        reason,
      };
      // 预收单入参
      const advances = advanceAmountList.filter(item => item.amount && item.id && Number(item.amount) > 0);
      if (advances.length) {
        params.newValueList = advanceAmountList.map((item) => {
          const obj = this.depositList.find(desItem => desItem.id === item.id);
          item.type = 2;
          item.name = `${obj.depositCode} ${obj.paymentUserName} ${item.amount}`;
          return item;
        });
      }
      // 新收款方式
      const payments = paymentList.filter(item => item.amount && Number(item.amount) > 0);
      if (payments.length) {
        const list = payments.map((item) => {
          const result = {};
          result.type = 1;
          result.name = `${item.proceedsTypeName} ${item.amount}`;
          result.id = item.proceedsTypeId;
          result.amount = item.amount;
          return result;
        });
        params.newValueList.push(...list);
      }
      // 收款单(退款)
      if (bizType == 4) {
        const obj = this.paymentList.find(subItem => subItem.proceedsTypeId == selectPayment.id);
        const result = {};
        result.name = `${obj.proceedsTypeName} ${Math.abs(selectPayment.amount)}`;
        result.id = obj.proceedsTypeId;
        result.amount = Math.abs(selectPayment.amount);
        params.newValueList.push(result);
      }
      if (selectPayment.amount && Number(selectPayment.amount) > 0) {
        const obj = this.paymentList.find(subItem => subItem.proceedsTypeId == selectPayment.id);
        const result = {};
        result.name = `${obj.proceedsTypeName} ${selectPayment.amount}`;
        result.id = obj.proceedsTypeId;
        result.amount = selectPayment.amount;
        params.newValueList.push(result);
      }
      // 更改销项税率入参
      if (saleOrderDetailList && saleOrderDetailList.length) {
        const list = [];
        saleOrderDetailList.forEach((item) => {
          if (item.outputTaxRateNew != item.outputTaxRate) {
            const result = {};
            result.id = item.id;
            result.name = `${item.drugSerialCode} ${item.approvedDrugNames} ${item.outputTaxRateNew}%`;
            result.amount = item.outputTaxRateNew;
            list.push(result);
          }
        });
        if (list.length === 0) {
          this.$Message.error('销项税率一致, 无法修改');
          this.formInfo.type = 1;
          return;
        }
        params.newValueList.push(...list);
      }
      // 预收退款
      if (refundList && refundList.length > 0) {
        refundList.forEach((item) => {
          const tempElement = {};
          tempElement.amount = item.amount;
          tempElement.id = item.proceedsTypeId;
          tempElement.name = `${item.proceedsTypeName} ${item.amount}`;
          tempElement.type = 1;
          params.newValueList.push(tempElement);
        });
      }
      if (refundData && refundData.length > 0) {
        refundData.forEach((item) => {
          const tempElement = {};
          tempElement.amount = item.refundAmount || 0;
          tempElement.id = item.financeDepositId;
          tempElement.detailId = item.financeDepositDetailId;
          tempElement.verificationType = item.verificationType;
          tempElement.name = `${item.depositCode} ${item.paymentUserName} ${item.refundAmount || 0}`;
          tempElement.type = 2;
          params.newValueList.push(tempElement);
        });
      }
      finance.revisionListAdd(params).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('保存成功');
          this.verifyListData = res.data.data;
          this.formInfo.type = 1;
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this.saveLoading = false;
        utils.handleError(err);
      });
      this.showRevisionModal = false;
    },
    handlerRevision(val) {
      this.formInfo.type = 1;
      const value = utils.deepClone(val);
      this.depositList = utils.deepClone(this.tempDepositList);
      if (value.depositFinanceDepositList) {
        value.depositFinanceDepositList.forEach((depositItem) => {
          const index = this.depositList.findIndex(deposit => deposit.id === depositItem.id);
          if (index < 0) {
            depositItem.deposit = depositItem.depositVerificationAmount;
            depositItem.createTime = utils.formatDate(depositItem.createTime);
            this.depositList.unshift(utils.deepClone(depositItem));
          } else {
            this.depositList[index].deposit += depositItem.depositVerificationAmount;
          }
        });
      }
      this.resetFormConfig();
      this.revisionSelectModal = true;
      const {
        referId,
        bizType,
        bizCode,
        proceedsId,
      } = value;
      this.tempRevisionList = [];
      if (bizType == 1) {
        this.tempRevisionList = this.revisionList;
        this.formInfo.type = 2;
        setTimeout(() => { // 设置延迟执行才可以，不知道什么原因
          this.formInfo.type = 1;
        }, 1);
      } else if (bizType === 2 || bizType === 4) {
        this.tempRevisionList = null;
        this.formInfo.type = 100; // 暂时这么处理
        this.tempRevisionList = [
          {
            id: 1,
            name: '修改退款方式',
          },
        ];
        setTimeout(() => { // 设置延迟执行才可以，不知道什么原因
          this.formInfo.type = 1;
        }, 1);
      } else {
        this.formInfo.type = 2;
        setTimeout(() => { // 设置延迟执行才可以，不知道什么原因
          this.formInfo.type = 1;
        }, 1);
        this.tempRevisionList = this.revisionList.filter(item => item.id === 1);
      }
      const obj = {
        orderTypeName: this.orderTypeList[bizType],
        bizCode,
        bizType,
        proceedsId,
        bizId: referId,
      };
      Object.assign(this.formInfo, obj);
      const arr = ['depositString', 'proceedsAmountString', 'receiveDepositString', 'depositAmountString'];
      arr.forEach((item) => {
        if (value[item] && value[item] !== '') {
          let tempArr = [];
          const str = value[item];
          if (str.indexOf(',') !== -1) {
            tempArr = str.split(',');
          } else {
            tempArr = [str];
          }
          value[item] = tempArr;
        } else {
          delete value[item];
        }
      });
      // if (value.proceedsAmountString) { // 暂时注释
      //   const data = value.proceedsAmountString;
      //   const list = [];
      //   for (let index = 0; index < data.length; index += 1) {
      //     const itm = data.splice(index, index + 3).join(',');
      //     list.push(itm);
      //   }
      // value.proceedsAmountString = list;
      // }
      if (value.depositAmountString) {
        value.depositAmountString = utils.deepClone(value.depositAmountString);
      }

      this.tempSaleOrderDetailList = value.saleOrderDetailList;
      this.formConfig.formData = value;
    },
    resetFormConfig() {
      this.formConfig = { // 订正配置
        formItem: [
          {
            name: '订正订单:',
            type: 'txt',
            key: 'bizCode',
          },
          {
            name: '订正类型:',
            type: 'txt',
            key: 'typeName',
          },
        ],
        formData: {},
        subParams: {
          advanceAmountList: [
            {
              type: 2,
            },
          ],
          paymentList: this.paymentList.filter(item => !([6].includes(item.proceedsTypeId))),
          selectPayment:
          {
            id: '',
            amount: '',
          },
          reason: '',
        },
      };
    },
    cancel() {
      this.revisionSelectModal = false;
      this.formInfo.type = 1;
      this.resetFormConfig();
    },
    handlerNext() {
      // revisionType 订正类型：1.销售订单-收款方式、2.销售订单-销项税率、3.退货单-收款方式、4.收款单-收款方式 5.退款方式
      const {
        type,
        bizType,
        bizCode,
      } = this.formInfo;
      let revisionType = 1;
      if (type == 1) {
        if (bizType == 1) {
          revisionType = 1;
          this.formConfig.formItem.push(
            {
              name: '总收款金额:',
              type: 'txt',
              key: 'proceedsAmount',
            },
            {
              name: '原预收核销:',
              type: 'ArrayTxt',
              key: 'depositString',
            },
            {
              name: '原应收核销:',
              type: 'ArrayTxt',
              key: 'receiveDepositString',
            },
            {
              name: '原其他收款:',
              type: 'ArrayTxt',
              key: 'proceedsAmountString',
            },
            {
              name: '新预收核销:',
              type: 'deposit',
            },
            {
              name: '新其他收款:',
              type: 'payment',
            },
          );
        }
        if (bizType == 2) {
          revisionType = 3;
          this.formConfig.formItem.push(
            {
              name: '总退款金额:',
              type: 'txt',
              key: 'amount',
            },
            {
              name: '原退款方式:',
              type: 'ArrayTxt',
              key: 'proceedsAmountString',
            },
            {
              name: '原核销退回:',
              type: 'depositAmount',
              key: 'depositAmountString',
            },
            {
              name: '退款信息:',
              type: 'morePayment',
            },
            {
              name: '预收核销退回:',
              type: 'proceedList',
            },
          );
        }
        if (bizType == 3) {
          revisionType = 4;
          this.formConfig.formItem.push(
            {
              name: '总收款金额:',
              type: 'txt',
              key: 'proceedsAmount',
            },
            {
              name: '原收款方式:',
              type: 'ArrayTxt',
              key: 'proceedsAmountString',
            },
            {
              name: '收款方式:',
              type: 'selectPayment',
              otherTxt: '收款金额',
            },
          );
        }
        if (bizType == 4) { // 退款方式
          revisionType = 5;
          this.formConfig.formItem.push(
            {
              name: '原退款方式:',
              type: 'ArrayTxt',
              key: 'proceedsAmountString',
            },
            {
              name: '新退款方式:',
              type: 'selectRefund',
            },
          );
        }
      } else if (type == 2 && bizType == 1) {
        revisionType = 2;
        this.formConfig.formItem.push(
          {
            name: '',
            type: 'table',
            tableName: 'saleOrderDetailList',
          },
        );
        const saleOrderDetailList = this.tempSaleOrderDetailList;
        this.formConfig.subParams.saleOrderDetailList = saleOrderDetailList;
        this.formConfig.formData.saleOrderDetailList = {
          columns: this.tableColumns,
          tableData: saleOrderDetailList,
        };
      }
      this.formConfig.formItem.push(
        {
          name: '订正原因:',
          type: 'reason',
        },
      );
      const errArr = [];
      this.verifyListData.forEach((item) => {
        if (bizCode == item.bizCode && revisionType == item.revisionType) {
          errArr.push(item);
        }
      });
      if (errArr.length) {
        this.$Message.warning('该单据已有此类型订正，请检查');
        this.resetFormConfig();
        return;
      }
      this.formInfo.revisionType = revisionType;
      this.revisionSelectModal = false;
      this.showRevisionModal = true;

      this.formConfig.formData.typeName = this.tempRevisionList.find(item => item.id == type).name;
      this.formConfig.formData.bizCode = bizCode;
    },
    getData() {
      finance.getFinanceProceedsInfo({ financeProceedsId: this.$route.params.id }).then((res) => {
        if (res.data.status === 200) {
          const result = res.data.data;
          this.subInfosArr = [
            {
              name: '门店',
              value: result.financeProceeds.storeName,
            },
            {
              name: '日期',
              value: utils.exchangeTimeToSecond(result.financeProceeds.createTime),
            },
            {
              name: '核验人',
              value: result.financeProceeds.modifiedUserName,
            },
          ];
          this.infosArr = [
            {
              name: '核验状态:',
              value: this.verifyStatus[result.financeProceeds.verifyStatus - 1],
            },
            {
              name: '核验时间:',
              value: result.financeProceeds.verifyTime ? utils.exchangeTimeToSecond(result.financeProceeds.verifyTime) : '',
            },
            {
              name: '推送状态:',
              value: this.pushStatus[result.financeProceeds.pushStatus - 1],
            },
            {
              name: '推送时间:',
              value: result.financeProceeds.pushTime ? utils.exchangeTimeToSecond(result.financeProceeds.pushTime) : '',
            },
          ];
          this.verifyStatusPage = this.verifyStatus[result.financeProceeds.verifyStatus - 1];
          this.code = result.financeProceeds.code;
          this.proceedsTotalInfo = result.proceedsTotalInfo;
          this.saleOrderListData = [];
          if (result.saleOrderList) {
            result.saleOrderList.forEach((item) => {
              item.proceedsId = item.saleOrder.id;
              item = Object.assign(item, item.saleOrder);
              item.createTime = utils.exchangeTimeToSecond(item.createTime);
              item.type = this.type[item.type - 1];
              // item.status = this.status[item.status - 1];
              item.signStatus = this.signStatus[item.signStatus - 1];
              item.proceedsStatus = this.proceedsStatus[item.proceedsStatus - 1];
              this.saleOrderListData.push(item);
            });
          }
          this.saleRefundListData = [];
          if (result.saleRefundList) {
            result.saleRefundList.forEach((item) => {
              item = Object.assign(item, item.saleRefund);
              item.createTime = utils.exchangeTimeToSecond(item.createTime);
              item.modifiedTime = utils.exchangeTimeToSecond(item.modifiedTime);
              item.status = this.returnStatus[item.status - 1];
              this.saleRefundListData.push(item);
            });
          }
          this.financeDepositListData = [];
          if (result.financeDepositList) {
            result.financeDepositList.forEach((item) => {
              item = Object.assign(item, item.financeDeposit);
              item.createTime = utils.exchangeTimeToSecond(item.createTime);
              this.financeDepositListData.push(item);
            });
          }
          this.verifyListData = result.verifyList;
          this.newChanges();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    submit(e) {
      const params = [];
      const list = [this.saleOrderListData, this.saleRefundListData, this.financeDepositListData];
      list.forEach((item) => {
        item.forEach((subItem) => {
          params.push({
            verifyStatus: subItem.verifyStatus,
            remarks: subItem.remarks,
            referId: subItem.referId,
            referType: subItem.bizType,
            proceedsId: subItem.proceedsId,
          });
        });
      });
      this.saveLoading = true;
      if (e === 2) {
        finance.verifyListAdd(params).then((res) => {
          if (res.data.status === 200) {
            this.$Message.success('保存成功');
            this.$router.push({ name: 'retailDaily' });
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          this.saveLoading = false;
          utils.handleError(err);
        });
      } else if (e === 1 && this.retailDailyRevision) {
        finance.verifyListSubmit(params).then((res) => {
          if (res.data.status === 200) {
            this.$Message.success('提交成功');
            this.$router.push({ name: 'retailDaily' });
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          this.saveLoading = false;
          utils.handleError(err);
        });
      } else {
        const param = {
          proceedsId: this.$route.params.id,
        };
        finance.revisionListSubmit(param).then((res) => {
          if (res.data.status === 200) {
            this.$Message.success('提交成功');
            this.$router.push({ name: 'retailDaily' });
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          this.saveLoading = false;
          utils.handleError(err);
        });
      }
    },
    confirmation(e) {
      const list = [this.saleOrderListData, this.saleRefundListData, this.financeDepositListData];
      this.$Modal.info({
        title: '是否批量确认无误',
        onOk: () => {
          list[e].forEach((item) => {
            this.$set(item, 'verifyStatus', 1);
          });
        },
      });
    },
    getPaymentList(goodsBaseIdList) {
      const params = {
        status: 1,
      };
      if (goodsBaseIdList) {
        params.goodsBaseIdList = goodsBaseIdList;
      }
      return new Promise((resolve) => {
        system.getStoreProceedsTypeList(params).then((res) => {
          if (res.data.status === 200) {
            this.paymentList = res.data.data.list;
            this.paymentListCopyed = utils.deepClone(this.paymentList);
            this.paymentList.forEach((item) => {
              item.amount = null;
            });
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    getDepositList() {
      return new Promise((resolve) => {
        sale.getExistReceivablesList().then((res) => {
          this.depositList = res;
          this.depositList.forEach((item) => {
            item.createTime = utils.formatDate(item.createTime);
          });
          this.tempDepositList = utils.deepClone(this.depositList);
          resolve();
        });
      });
    },
    revisionRecordDeletion(e) {
      finance.revisionRecordDeletion(e);
    },
    amountAdjust(v) {
      if (v !== undefined) {
        return `（${v}）`;
      }
      return '';
    },
    newChanges() {
      const collectionArr = []; // 收款方式arr
      const rateArr = []; // 税率数组
      if (this.verifyListData.length) {
        this.verifyListData.forEach((item) => {
          let obj = {};
          if (item.bizType === 1) {
            if (item.revisionType === 1) { // 订正类型为收款方式
              if (!item.newValueDescription.indexOf(',')) { // 只有收款金额一条或者预收核销一条的情况
                if (item.newValueDescription.slice(0, 2) === 'SK') {
                  obj.depositStringAll = item.newValueDescription;
                } else {
                  obj.proceedsAmountString = item.newValueDescription;
                }
              } else { // 有多条收款金额或者预收核销的情况
                obj = {
                  depositStringAll: '',
                  proceedsAmountString: '',
                  orderNo: '',
                };
                const newArr = item.newValueDescription.split(',');
                newArr.forEach((subitem) => {
                  if (subitem.slice(0, 2) === 'SK') {
                    obj.depositStringAll += `${subitem}，`;
                  } else {
                    obj.proceedsAmountString += `${subitem}，`;
                  }
                });
                obj.depositStringAll = obj.depositStringAll.substring(0, obj.depositStringAll.length - 1);
                obj.proceedsAmountString = obj.proceedsAmountString.substring(0, obj.proceedsAmountString.length - 1);
              }
              obj.orderNo = item.bizCode;
              collectionArr.push(obj);
            } else if (item.revisionType === 2) {
              const taxRates = {// 销项税率
                commodityCode: '', // 商品编码
                commodityTax: '', // 商品税率
                tax: '', // 税率是否变化
              };
              const taxRatesArr = []; // 多个销项税率
              if (item.newValueDescription.indexOf(',') === -1) { // 只有一条销售税率的情况
                taxRates.commodityCode = item.newValueDescription.substring(0, item.newValueDescription.indexOf(' '));
                taxRates.commodityTax = item.newValueDescription.substring(item.newValueDescription.lastIndexOf(' ') + 1, item.newValueDescription.indexOf('%'));
                taxRates.tax = 1;
                taxRatesArr.push(taxRates);
                obj.taxRatesArr = taxRatesArr;
              } else {
                const taxArr = item.newValueDescription.split(',');
                const oldValueTaxArr = item.oldValue.split(',');
                for (let i = 0; i < taxArr.length; i++) {
                  taxRates.commodityCode = taxArr[i].substring(0, taxArr[i].indexOf(' '));
                  taxRates.commodityTax = taxArr[i].substring(taxArr[i].lastIndexOf(' ') + 1, taxArr[i].indexOf('%'));
                  if (oldValueTaxArr[i].substring(taxArr[i].lastIndexOf(' ') + 1, taxArr[i].indexOf('%')) !== taxRates.commodityTax) {
                    taxRates.tax = 1;
                  }
                  taxRatesArr.push(taxRates);
                  obj.taxRatesArr = taxRatesArr;
                }
              }
              obj.orderNo = item.bizCode;
              rateArr.push(obj);
            }
          } else if (item.bizType === 2) { // 退货单修改内容
            obj.orderNo = item.bizCode;
            obj.newValue = item.newValueDescription;
            if (!item.newValueDescription.indexOf(',')) { // 只有收款金额一条或者预收核销一条的情况
              if (item.newValueDescription.slice(0, 2) === 'SK') {
                obj.newDepositAmountString = item.newValueDescription;
              } else {
                obj.proceedsAmountString = item.newValueDescription;
                obj.newValue = obj.proceedsAmountString;
                obj.newDepositAmountString = '';
              }
            } else { // 有多条收款金额或者预收核销的情况
              obj = {
                newDepositAmountString: '',
                proceedsAmountString: '',
                orderNo: '',
              };
              obj.orderNo = item.bizCode;
              const newArr = item.newValueDescription.split(',');
              newArr.forEach((subitem) => {
                if (subitem.slice(0, 2) === 'SK') {
                  obj.newDepositAmountString += `${subitem}，`;
                } else {
                  obj.proceedsAmountString += `${subitem}，`;
                }
              });
              obj.newDepositAmountString = obj.newDepositAmountString.substring(0, obj.newDepositAmountString.length - 1);
              obj.proceedsAmountString = obj.proceedsAmountString.substring(0, obj.proceedsAmountString.length - 1);
              obj.newValue = obj.proceedsAmountString;
            }
            collectionArr.push(obj);
          } else if (item.bizType === 3 || item.bizType === 4) { // 收款单修改内容 || // 收款单退款
            obj.orderNo = item.bizCode;
            obj.newValue = item.newValueDescription.substring(0, item.newValueDescription.indexOf(' '));
            collectionArr.push(obj);
          }
        });
        this.saleOrderListData.forEach((item) => {
          collectionArr.forEach((subitem) => {
            if (item.orderNo === subitem.orderNo) {
              item.depositStringAll = subitem.depositStringAll;
              item.proceedsAmountString = subitem.proceedsAmountString;
              item.flag = 1;
              item.saleOrderDetailList.taxRatesArr = subitem.taxRatesArr;
            }
          });
        });
        this.saleOrderListData.forEach((item) => { // 给每个详情列表加上销项税率字段
          item.saleOrderDetailList.forEach((subitem) => {
            subitem.taxRates = {};
          });
        });
        this.saleOrderListData.forEach((item) => {
          rateArr.forEach((subitem) => {
            if (item.orderNo === subitem.orderNo) {
              for (let i = 0; i < item.saleOrderDetailList.length; i++) {
                item.saleOrderDetailList[i].taxRates = subitem.taxRatesArr[i];
                item.saleOrderDetailList[i].outputTaxRate = subitem.taxRatesArr[i].commodityTax;
              }
            }
          });
        });
        this.saleRefundListData.forEach((item) => {
          collectionArr.forEach((subitem) => {
            if (item.bizCode === subitem.orderNo) {
              item.newValue = subitem.newValue;
              item.newDepositAmountString = subitem.newDepositAmountString;
              item.showNewDepositAmountString = true;
              item.showNewValue = true;
            }
          });
        });
        this.financeDepositListData.forEach((item) => {
          collectionArr.forEach((subitem) => {
            if (item.bizCode === subitem.orderNo) {
              item.newValue = subitem.newValue;
            }
          });
        });
      }
    },
  },
  created() {
  },
  mounted() {
    Promise.all([
      this.getDepositList(),
      this.getPaymentList(),
    ]).then(() => {
      this.getData();
    });
  },
};
</script>
<style lang="less" scoped>
.card-space {
  margin-top: 10px;
}
</style>
